(() => {
  'use strict';
  const text=JSON.parse(document.getElementById('ph-hydro-cart-text').textContent);
  const addonProductId=15877022253430;
  const legacyIds=new Set([15471489384822, 15471490007414, 15471490728310, 15471491088758, 15471491547510, 15471491940726, 15475088982390, 15475089080694, 15475089178998, 15475089670518, 15478739403126, 15478739665270, 15478752772470, 15478754574710, 15478757491062, 15475089834358, 15475089932662, 15478760407414]);
  let checking=false, resume=false;
  const root=()=>window.Shopify?.routes?.root||'/';
  async function check(event,element,submitter) {
    if(resume){resume=false;return;}
    event.preventDefault();event.stopImmediatePropagation();
    if(checking)return;checking=true;
    try {
      const response=await fetch(root()+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error(text.cart_error);
      const cart=await response.json();
      if(cart.items.some(item=>legacyIds.has(item.product_id)))throw new Error(text.legacy_error);
      const orphan=cart.items.some(item=>item.product_id===addonProductId&&(!item.parent_relationship?.parent_key||!cart.items.some(parent=>parent.key===item.parent_relationship.parent_key&&parent.properties?._ph_hydro_config)));
      if(orphan)throw new Error(text.orphan_error);
      resume=true;
      if(element.tagName==='FORM')element.requestSubmit(submitter||undefined);else element.click();
    }catch(error){
      let notice=document.getElementById('ph-hydro-cart-error');
      if(!notice){notice=document.createElement('p');notice.id='ph-hydro-cart-error';notice.setAttribute('role','alert');notice.tabIndex=-1;notice.style.cssText='padding:16px;border:2px solid #a4382b;background:#fff4f1;color:#842d22;line-height:1.5';element.insertAdjacentElement('beforebegin',notice);}
      notice.textContent=error.message;notice.focus();
    }finally{checking=false;}
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href="/checkout"],a[href^="/checkout?"]');
    if(link)check(event,link);
  },true);
  document.addEventListener('submit',event=>{
    if(event.submitter?.name==='checkout')check(event,event.target,event.submitter);
  },true);
})();
